import React from 'react';
import styled from 'styled-components';
import { object, bool } from 'prop-types';
import {
  createScopedTranslate,
  getUsableBigPointsText,
} from '@airasia-common/libraries/i18n/LocaleHelper';
import { Text, Wrapper, Column, Row } from '../';
import Icon from '../Icon';

const commonTranslate = createScopedTranslate('common');

const CloseIcon = styled(Icon)`
  position: absolute;
  right: 20px;
  color: ${({ theme }) => theme.colors.greyDark};
`;

const SmallText = styled(Text)`
  color: ${props => props.color};
  font-weight: 400;
  line-height: 18px;
  font-size: 12px;
`;

const MediumText = styled(Text)`
  color: ${props => props.color};
  font-weight: 400;
  line-height: 21px;
  font-size: 14px;
`;

const HeadLineText = styled(Text)`
  color: ${props => props.color};
  font-weight: 500;
  line-height: 24px;
  font-size: 16px;
`;

const BigpointsInfo = props => {
  const { bigPoints, isMobileView, closeModal } = props;
  const availableBalance = `${bigPoints.available_amount.currency} ${bigPoints.available_amount.value}`;
  return !isMobileView ? (
    <>
      <HeadLineText color={'black'}>
        {commonTranslate('bigpointsTooltip.title.web')}
      </HeadLineText>
      <Row marginTop={2} marginBottom={2}>
        <MediumText color={'greyDarker'}>
          {commonTranslate('bigpointsTooltip.value.web')}
        </MediumText>
        &nbsp;
        <MediumText color={'black'}>{availableBalance}</MediumText>
      </Row>
      <SmallText color={'greyDarker'}>
        {getUsableBigPointsText(bigPoints.max_payable_percentage)}
      </SmallText>
      <SmallText color={'greyDark'}>
        {commonTranslate('bigpointsTooltip.note')}
      </SmallText>
    </>
  ) : (
    <Column
      marginBottom={4}
      marginLeft={12}
      marginRight={12}
      borderRadius={6}
      paddingX={4}
      paddingY={4}
      height={'fit-content'}
    >
      <Row>
        <CloseIcon icon="CloseIcon" fontsize={24} onClick={closeModal} />
        <Wrapper marginTop={34}>
          <HeadLineText color={'black'}>
            {commonTranslate('bigpointsTooltip.title')}
          </HeadLineText>
          <Row marginTop={2}>
            <MediumText color={'greyDarker'}>
              {commonTranslate('bigpointsTooltip.value')}
            </MediumText>
            &nbsp;
            <MediumText color={'black'}>{availableBalance}</MediumText>
          </Row>
          <Row marginBottom={2}>
            <MediumText color={'greyDarker'}>
              {commonTranslate('bigpointsTooltip.balance')}
            </MediumText>
            &nbsp;
            <MediumText color={'black'}>
              {bigPoints.available_big_points}
            </MediumText>
          </Row>
          <SmallText color={'greyDarker'}>
            {getUsableBigPointsText(bigPoints.max_payable_percentage)}
          </SmallText>
          <SmallText color={'greyDark'}>
            {commonTranslate('bigpointsTooltip.note')}
          </SmallText>
        </Wrapper>
      </Row>
    </Column>
  );
};

BigpointsInfo.propTypes = {
  bigPoints: object,
  isMobileView: bool,
  closeModal: bool,
};

export default BigpointsInfo;
